
import Vue from 'vue'
import VSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { RSelectState, CountryOption } from './types'
import { getCountryName, getCountryOptions } from './helpers'

import RFlag from '@/components/icons/RFlag.vue'

export default Vue.extend({
  name: 'RSelect',
  props: {
    value: {
      type: [String, Object],
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    country: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RFlag,
    VSelect,
  },
  data(): RSelectState {
    return {
      actualOptions: null,
    }
  },
  created() {
    this.actualOptions = this.country ? getCountryOptions() : this.options
  },
  methods: {
    setValue(value: CountryOption | any): void {
      this.$emit('input', value ? (this.country ? value.code : value) : null)
    },
  },
  computed: {
    displayValue(): string | null {
      if (this.value) {
        return this.country ? getCountryName(this.value) : this.value
      }
      return null
    },
    classes(): string[] {
      return ['r-select', this.country ? 'country' : '', this.fullWidth ? 'full-width' : '']
    },
  },
})
